import { useEffect, useState } from "react";

// Phones, landscape phones and portrait tablets get a dedicated vertical layout; tablets and
// desktops keep the 3D world.
export const MOBILE_QUERY =
  "(max-width: 767px), (max-height: 480px) and (pointer: coarse), (max-width: 1024px) and (orientation: portrait) and (pointer: coarse)";

export function isMobileLayout() {
  return typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobileLayout() {
  const [mobile, setMobile] = useState(isMobileLayout);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const on = () => setMobile(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
}
